import { progressText, organizationSetupSections } from "./constant";
import { ProgressBar } from "shared/dist/components";
import { organizationSetupRoutes } from "./Routes";
import { useSelector, useDispatch } from "react-redux";
import { organizationActions } from "../../Services/Redux/actionCreators";
import { useEffect, useState } from "react";
import { Outlet, useLocation, useOutletContext } from "react-router";
import { useNavigateTo } from "../../GlobalRouter/hook/NavigateTo";
import PageHeading from "../../Components/PageFormComponents/PageHeading";
import PageContainer from "../../Components/PageFormComponents/PageContainer";
import { SET_ORGANIZATION_STATUS } from "../../Services/Redux/actionCreators/organizationActions";

const OrganizationSetup = () => {
    const navigateTo = useNavigateTo();
    const { pathname } = useLocation();
    const organization = useSelector((state) => state.organization);
    const dispatch = useDispatch();
    const [activeSection, setActiveSection] = useState(
        organizationSetupSections.ORGANIZATION_PROFILE
    );

    const handleFinishLater = async () => {
        await dispatch(organizationActions.finishLater(organization));
        if (organization.foundInBlockchain) {
            navigateTo.services({ orgUuid: organization.uuid });
            return;
        }
        navigateTo.organizationSetup({ orgUuid: organization.uuid }, SET_ORGANIZATION_STATUS.path);
    };

    useEffect(() => {
        const [activeTab] = Object.entries(organizationSetupRoutes).filter((route) => {
            return pathname?.includes(route[1].path) && !route[1].index;
        });
        setActiveSection(
            organizationSetupSections[activeTab[0]] ??
                organizationSetupSections.ORGANIZATION_PROFILE
        );
    }, [pathname]);

    const handleSectionClick = (progressNumber) => {
        const clickedSection = Object.entries(organizationSetupSections).find(
            (section) => section[1].key === progressNumber
        );
        if (clickedSection) {
            navigateTo.organizationSetup(
                { orgUuid: organization.uuid },
                organizationSetupRoutes[clickedSection[0]].path
            );
        }
    };

    if (!activeSection) {
        return null;
    }

    return (
        <div>
            <PageHeading {...activeSection.heading} />
            <ProgressBar
                activeSection={activeSection?.key ?? 0}
                progressText={progressText}
                onSectionClick={(progressNumber) => handleSectionClick(progressNumber)}
            />
            <PageContainer>
                <Outlet context={{ handleFinishLater }} />
            </PageContainer>
        </div>
    );
};

export default OrganizationSetup;

export function useFinishLater() {
    return useOutletContext();
}
